<template>
  <WdsAlert info :title="$t('Note')">
    <template #description>
      <p>
        Due to your existing contracts or payments you’re not able to change your business entity
        type.
      </p>

      <p>
        If you need to change your business settings on an active contract, your client will need to
        cancel the current contract first. You will then be able to change your business entity
        settings, and your client can then offer a new contract to you.
      </p>

      <p>Please reach out to Worksome if you need any help or have questions.</p>
    </template>
  </WdsAlert>
</template>

<script>
import { WdsAlert } from '@worksome/wds-components'

export default {
  components: {
    WdsAlert,
  },
}
</script>
